import { Component, OnInit } from '@angular/core';
import { NbButtonModule, NbCardModule, NbDialogRef, NbIconModule } from '@nebular/theme';
import { UtilityService } from 'src/app/core/services/utility.service';
import { SourceImage } from 'src/app/models/drb-models/source-image';
@Component({
  selector: 'app-view-image',
  templateUrl: './view-image.component.html',
  styleUrls: ['./view-image.component.css'],
  imports: [NbCardModule, NbIconModule, NbButtonModule]
})
export class ViewImageComponent implements OnInit {
  public image: SourceImage;

  constructor(
    protected ref: NbDialogRef<ViewImageComponent>,
    public utility: UtilityService
  ) {}

  public ngOnInit() {}

  public close() {
    this.ref.close();
  }
}
